import { render, staticRenderFns } from "./SocialValueInfo.vue?vue&type=template&id=3a43527e&scoped=true&"
import script from "./SocialValueInfo.vue?vue&type=script&lang=js&"
export * from "./SocialValueInfo.vue?vue&type=script&lang=js&"
import style0 from "./SocialValueInfo.vue?vue&type=style&index=0&id=3a43527e&scoped=true&lang=css&"
import style1 from "./SocialValueInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43527e",
  null
  
)

export default component.exports